export default [
  {
    code: "EUR",
    name: "Euro",
    language: "es-ES",
    symbol: "&euro;",
    position: "right",
  },
  {
    code: "USD",
    name: "Dólar Estadounidense",
    language: "en-US",
    symbol: "$",
    position: "left",
  },
  {
    code: "GBP",
    name: "Libra Esterlina",
    language: "en-GB",
    symbol: "&pound;",
    position: "left",
  },
  {
    code: "AED",
    name: "Dírham de los Emiratos Árabes Unidos",
    language: "en-US",
    symbol: "DH",
    position: "right",
  },
  {
    code: "AUD",
    name: "Dólar Australiano",
    language: "en-AU",
    symbol: "A$",
    position: "left",
  },
  {
    code: "ARS",
    name: "Peso Argentino",
    language: "es-AR",
    symbol: "AR$",
    position: "left",
  },
  {
    code: "BOB",
    name: "Bolívar Boliviano",
    language: "es-BO",
    symbol: "Bs",
    position: "left",
  },
  {
    code: "BGN",
    name: "Leva Búlgara",
    language: "bg-BG",
    symbol: "&#1083;&#1074;",
    position: "right",
  },
  {
    code: "BHD",
    name: "Dinar Bahreiní",
    language: "en-US",
    symbol: "BD",
    position: "left",
  },
  {
    code: "BRL",
    name: "Real Brasileño",
    language: "pt-BR",
    symbol: "R$",
    position: "left",
  },
  {
    code: "CAD",
    name: "Dólar Canadiense",
    language: "en-CA",
    symbol: "CA$",
    position: "left",
  },
  {
    code: "CHF",
    name: "Franco Suizo",
    language: "fr-CH",
    symbol: "CHF",
    position: "left",
  },
  {
    code: "CRC",
    name: "Colón Costaricense",
    language: "es-CR",
    symbol: "&#8353;",
    position: "left",
  },
  {
    code: "CNY",
    name: "Yuan Renminbi Chino",
    language: "zh-CN",
    symbol: "CN&yen;",
    position: "left",
  },
  {
    code: "CLF",
    name: "Unidad de Fomento Chilena(UF)",
    language: "es-CL",
    symbol: "UF",
    position: "left",
  },
  {
    code: "CLP",
    name: "Peso Chileno",
    language: "es-CL",
    symbol: "CLP$",
    position: "left",
  },
  {
    code: "COP",
    name: "Peso Colombiano",
    language: "es-CO",
    symbol: "COL$",
    position: "left",
  },
  {
    code: "CZK",
    name: "Corona Checa",
    language: "cs-CZ",
    symbol: "&#75;&#269;",
    position: "right",
  },
  {
    code: "DKK",
    name: "Corona Danesa",
    language: "da-DK",
    symbol: "&#107;&#114;",
    position: "right",
  },
  {
    code: "EGP",
    name: "Libra Egipcia",
    language: "en-GB",
    symbol: "E&pound;",
    position: "left",
  },
  {
    code: "GTQ",
    name: "Quetzal Guatemalteco",
    language: "es-GT",
    symbol: "Q",
    position: "left",
  },
  {
    code: "GYD",
    name: "Dólar Guayanés",
    language: "fr-FR",
    symbol: "G$",
    position: "left",
  },
  {
    code: "HNL",
    name: "Lempira Hondureña",
    language: "es-HN",
    symbol: "L",
    position: "left",
  },
  {
    code: "HKD",
    name: "Dólar de Hong Kong",
    language: "zh-HK",
    symbol: "HK$",
    position: "left",
  },
  {
    code: "HRK",
    name: "Kuna Croata",
    language: "hr-HR",
    symbol: "&#107;&#110;",
    position: "right",
  },
  {
    code: "HUF",
    name: "Florín Húngaro",
    language: "hu-HU",
    symbol: "&#70;&#116;",
    position: "right",
  },
  {
    code: "IDR",
    name: "Rupia Indonesia",
    language: "id-ID",
    symbol: "&#82;&#112;",
    position: "left",
  },
  {
    code: "ILS",
    name: "Shequel Israelí",
    language: "he-IL",
    symbol: "&#8362;",
    position: "right",
  },
  {
    code: "INR",
    name: "Rupia India",
    language: "hi-IN",
    symbol: "Rs",
    position: "left",
  },
  {
    code: "JPY",
    name: "Yen Japonés",
    language: "ja-JP",
    symbol: "&yen;",
    position: "left",
  },
  {
    code: "KRW",
    name: "Won Surcoreano",
    language: "ko-KR",
    symbol: "&#8361;",
    position: "left",
  },
  {
    code: "MAD",
    name: "Dirham Marroquí",
    language: "en-US",
    symbol: "dh",
    position: "left",
  },
  {
    code: "MUR",
    name: "Rupia Mauriciana",
    language: "en-US",
    symbol: "Rs",
    position: "left",
  },
  {
    code: "MXN",
    name: "Peso Mexicano",
    language: "es-MX",
    symbol: "Mex$",
    position: "left",
  },
  {
    code: "MYR",
    name: "Ringgit Malasio",
    language: "ms-MY",
    symbol: "&#82;&#77;",
    position: "left",
  },
  {
    code: "NGN",
    name: "Naira Nigeriana",
    language: "en-US",
    symbol: "&#8358;",
    position: "left",
  },
  {
    code: "NIO",
    name: "Córdoba Nicaragüense",
    language: "es-NI",
    symbol: "C$",
    position: "left",
  },
  {
    code: "NOK",
    name: "Corona Noruega",
    language: "nb-NO",
    symbol: "&#107;&#114;",
    position: "left",
  },
  {
    code: "NZD",
    name: "Dólar Neozelandés",
    language: "en-NZ",
    symbol: "NZ$",
    position: "left",
  },
  {
    code: "PEN",
    name: "Sol Peruano",
    language: "es-PE",
    symbol: "S/",
    position: "left",
  },
  {
    code: "PHP",
    name: "Peso Filipino",
    language: "en-PH",
    symbol: "&#8369;",
    position: "left",
  },
  {
    code: "PKR",
    name: "Rupia Pakistaní",
    language: "en-US",
    symbol: "Rs",
    position: "left",
  },
  {
    code: "PLN",
    name: "Zloty Polaco",
    language: "pl-PL",
    symbol: "&#122;&#322;",
    position: "right",
  },
  {
    code: "PYG",
    name: "Guaraní Paraguayo",
    language: "es-PY",
    symbol: "&#8370;",
    position: "left",
  },
  {
    code: "RON",
    name: "Nuevo Leu Rumano",
    language: "ro-RO",
    symbol: "&#108;&#101;&#105;",
    position: "right",
  },
  {
    code: "RUB",
    name: "Rublo Ruso",
    language: "ru-RU",
    symbol: "&#1088;&#1091;&#1073;",
    position: "right",
  },
  {
    code: "RSD",
    name: "Dinar Serbio",
    language: "sr-SR",
    symbol: "din",
    position: "right",
  },
  {
    code: "UYU",
    name: "Peso Uruguayo",
    language: "es-UY",
    symbol: "$U",
    position: "left",
  },
  {
    code: "SAR",
    name: "Riyal Saudí",
    language: "en-US",
    symbol: "&#65020;",
    position: "left",
  },
  {
    code: "SEK",
    name: "Corona Sueca",
    language: "sv-SE",
    symbol: "&#107;&#114;",
    position: "right",
  },
  {
    code: "SGD",
    name: "Dólar de Singapur",
    language: "zh-SG",
    symbol: "S$",
    position: "left",
  },
  {
    code: "SRD",
    name: "Dólar Surinamés",
    language: "nl-NL",
    symbol: "SRD$",
    position: "left",
  },
  {
    code: "THB",
    name: "Baht Tailandés",
    language: "th-TH",
    symbol: "&#3647;",
    position: "left",
  },
  {
    code: "TRY",
    name: "Lira Turca",
    language: "tr-TR",
    symbol: "&#8378;",
    position: "right",
  },
  {
    code: "TWD",
    name: "Nuevo dólar taiwanés",
    language: "zh-tw",
    symbol: "NT&#36;",
    position: "left",
  },
  {
    code: "UAH",
    name: "Grivna Ucraniana",
    language: "uk-UA",
    symbol: "&#8372;",
    position: "left",
  },
  {
    code: "VEF",
    name: "Bolívar Venezolano",
    language: "es-VE",
    symbol: "Bs.F",
    position: "left",
  },
  {
    code: "XAF",
    name: "Franco CFA de África Central",
    language: "fr-FR",
    symbol: "FCFA",
    position: "right",
  },
  {
    code: "XOF",
    name: "Franco CFA de África Occidental",
    language: "fr-FR",
    symbol: "CFA",
    position: "right",
  },
  {
    code: "ZAR",
    name: "Rand Sudafricano",
    language: "en-ZA",
    symbol: "&#82;",
    position: "left",
  },
];
